import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params = null, callbackFinally = null) => {
    return AppModel.get(
      'spec/image',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        let modelStore = store.getters.model
        if (!modelStore) {
          modelStore = {}
        }

        modelStore['specImage'] = res.data
        store.commit('setModel', modelStore)

        return Promise.resolve(res.data)
      },
      null, callbackFinally
    )
  },
  postApi: (bvModal, params, callback, errorCallback = null) => {
    return AppModel.post(
      'spec/image_update',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      errorCallback, callback
    )
  },
  putApi: (bvModal, params, callbackFinally) => {
    return AppModel.put(
      'spec/image_update',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  deleteApi: (bvModal, params = null, callbackFinally) => {
    return AppModel.delete(
      'spec/image_update',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  getStore: (key) => {
    return AppModel.getStore('specImage', key)
  },
  removeStore: () => {
    delete store.getters.model.agenda
  }
}



// WEBPACK FOOTER //
// ./src/models/SpecImageModel.js